import React from 'react';

import classes from './ScoringRuleModal.module.scss';
import { LbBigModal } from '../../../../../../shared/components/modals';
import { ScoringRuleItem } from './ScoringRuleItem/ScoringRuleItem';
import { scoringRulesContent } from './ScoringRuleModal.settings';
import { ScoringRuleType } from '../../../../../constants/scoringRule';

type ScoringRuleModalProps = {
  open: boolean;
  scoringRuleType: ScoringRuleType;
  onClose: () => void;
};

const ScoringRuleModal = ({ open, scoringRuleType, onClose }: ScoringRuleModalProps) => {
  return (
    <LbBigModal
      title="Scoring & Ranking Rules"
      open={open}
      onClose={onClose}
      buttonOptions={{
        noText: 'Close',
        noHandler: onClose,
        yesVisible: false,
      }}
    >
      <div className={classes.content}>
        {scoringRulesContent[scoringRuleType].map((item, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <ScoringRuleItem key={index} item={item} />
        ))}
      </div>
    </LbBigModal>
  );
};

export { ScoringRuleModal };
